import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class TransferOwnershipDataService {
	private basePath: string = `${environment.url}/api/TransferOwnership/`;

	constructor(private http: HttpClient) {}

	submit(values, partnerCode) {
		let headers = new HttpHeaders();
		headers = headers.set('partnerCode', partnerCode);
		return this.http.post<any>(`${this.basePath}Submit`, values, { headers: headers });
	}

	getAllProduct(id: string, partnerCode) {
		let headers = new HttpHeaders();
		headers = headers.set('partnerCode', partnerCode);
		return this.http.get<any>(
			`${this.basePath}GetAllProduct/${id}`,{ headers: headers }
		);
	}

	editExistingQuotes(id: string, values: any) {
		return this.http.post<any>(
			`${this.basePath}EditExistingQuotes/${id}`,
			values,
		);
	}

	editSpecificQuotes(id: string, values: any) {
		return this.http.post<any>(
			`${this.basePath}EditSpecificQuotes/${id}`,
			values,
		);
	}

	getHirePurchaseList() {
		return this.http.get<any>(`${this.basePath}GetHirePurchaseList`);
	}

	submitOrder(id: string, values: any) {
		return this.http.post<any>(`${this.basePath}SubmitOrder/${id}`, values);
	}
}
